module.exports = __webpack_public_path__ + "static/media/g2_logo.5da14bf8.svg";